import { FC } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import CommonLayout from "../AccountPage/CommonLayout";
import ModernSpacesContainer from "../../../components/Client/ModernSpacesContainer";
import "components/Payment/PaymentAnimations.css";

export interface ModernUncompletedLocationsProps {
  className?: string;
}

const ModernUncompletedLocations: FC<ModernUncompletedLocationsProps> = ({ className = "" }) => {
  return (
    <div className={`nc-ModernUncompletedLocations ${className}`}>
      <Helmet>
        <title>Mes Espaces - EventToBee | Gérez vos espaces événementiels</title>
        <meta
          name="description"
          content="Gérez tous vos espaces événementiels sur EventToBee. Suivez le statut de vos demandes, complétez vos annonces et développez votre activité."
        />
        <meta
          name="keywords"
          content="espaces événementiels, gestion espaces, EventToBee, locations, dashboard propriétaire"
        />
      </Helmet>

      <CommonLayout>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative overflow-hidden"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/30 via-white to-blue-50/30 dark:from-emerald-950/20 dark:via-gray-900 dark:to-blue-950/20">
            <div
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2310B981' fill-opacity='0.03'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
              }}
            ></div>
          </div>

          <div className="relative z-10">
            <ModernSpacesContainer className="animate-fade-in" />
          </div>

          {/* Floating Elements */}
          <div className="fixed inset-0 pointer-events-none overflow-hidden">
            {[...Array(8)].map((_, i) => (
              <motion.div
                key={i}
                className={`absolute w-1 h-1 rounded-full ${
                  i % 3 === 0 ? "bg-emerald-400/30" : i % 3 === 1 ? "bg-blue-400/30" : "bg-purple-400/30"
                }`}
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                }}
                animate={{
                  y: [0, -40, 0],
                  x: [0, 20, 0],
                  opacity: [0.3, 0.8, 0.3],
                  scale: [1, 1.5, 1],
                }}
                transition={{
                  duration: 12 + Math.random() * 8,
                  repeat: Infinity,
                  delay: Math.random() * 10,
                  ease: "easeInOut",
                }}
              />
            ))}
          </div>
        </motion.div>
      </CommonLayout>
    </div>
  );
};

export default ModernUncompletedLocations;
